import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8eed18e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-2" }
const _hoisted_2 = { class: "flexcontainer gap-2" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "bg-primary flex justify-center items-center p-1 rounded-t"
}
const _hoisted_7 = { class: "text-white text-lg" }
const _hoisted_8 = { class: "card-body p-4 flex flex-col" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "font-opensans text-black font-semibold" }
const _hoisted_11 = { class: "card-data text-black mt-2" }
const _hoisted_12 = { class: "text-justify text-black" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex rounded-full btnpills font-opensans text-xs font-bold bg-green text-white px-2 py-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Completed")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex rounded-full btnpills font-opensans text-xs font-bold bg-inprogress text-white px-2 py-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "In Progress")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex rounded-full btnpills font-opensans text-xs font-bold bg-red text-white px-2 py-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Overdue")
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex rounded-full btnpills font-opensans text-xs font-bold bg-notStarted text-white px-2 py-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Not Started")
], -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("figure", null, [
            (_ctx.allCourses.courseImageUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.Images(_ctx.allCourses),
                  class: "bg-cover bg-no-repeat bg-center rounded-t"
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.allCourses.courseName), 1)
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.allCourses.courseName), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.allCourses.courseDescription), 1)
            ])
          ]),
          (_ctx.allCourses.statusCodeId == 10403)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "cursor-pointer cardfooter h-5 items-center font-opensans font-bold text-xs flex justify-between mt-2",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, _hoisted_14))
            : _createCommentVNode("", true),
          (_ctx.allCourses.statusCodeId == 10402)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "cursor-pointer cardfooter h-5 items-center font-opensans font-bold text-xs flex mt-2",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, _hoisted_16))
            : _createCommentVNode("", true),
          (_ctx.allCourses.statusCodeId == 10404)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "cursor-pointer cardfooter h-5 items-center font-opensans font-bold text-xs flex mt-2",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, _hoisted_18))
            : _createCommentVNode("", true),
          (_ctx.allCourses.statusCodeId == 10401)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "cursor-pointer cardfooter h-5 items-center font-opensans font-bold text-xs flex mt-2",
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
              }, _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}